import styled from "styled-components";
import {colors} from "utils/colors";

export const Root = styled.div`
  width: 100%;
  height: 580px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px 30px 20px;
  background-color: #fff;
  border-radius: 8px;
`

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Title = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: ${colors.gray[700]};
`

export const Content = styled.div`
  flex-grow: 1;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;

  .ant-empty {
    width: 100%;
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`

export const LoadingWrapper = styled.div`
  width: 100%;
  height: 80%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  > div:last-child {
    font-size: 12px;
    color: ${colors.gray[400]};
  }
`
